<template>
<div class="view">
    <div class="viewTitle">Pedido Items</div>
    <div class="view-content">
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-grid">
                    <InputText label="Codigo pedido" v-model="pedido_items.pei_codigo"></InputText>
                    <InputSelect id="piEstados" label="Estados" v-model="pedido_items.est_codigo" :source="estados" itemKey="est_codigo" itemValue="est_codigo" :filterFunction="filterEstados"
                        :labelFunction="setEstado">
                        <template #default="data">
                            {{ setEstado(data.item) }}
                        </template>
                    </InputSelect>
                    <InputSelect id="piAlmacenes" label="Almacenes" v-model="pedido_items.alm_id" :source="almacenes" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacenes"
                        :labelFunction="labelAlmacen">
                        <template #default="data">
                            {{ labelAlmacen(data.item) }}
                        </template>
                    </InputSelect>
                </div>
                <br>
                <div class="nj-flex">
                    <Button icon="find" label="Buscar" @click="buscar()"></Button>
                    <Button icon="add" color="green" label="Nuevo" @click="popup({ componente: 'registrar', activar: true })"></Button>
                </div>
                <br>
                <div class="nj-panel-content">
                    <b-table :data="pedido_items.page.list" @page-change="changePage($event)" :total="pedido_items.page.total" :per-page="pedido_items.page.size"
                        :current-page="pedido_items.page.number" pagination-position="bottom" :pagination-rounded="true" :paginated="true" :backend-pagination="true">
                        <template slot-scope="props">
                            <b-table-column label="ID" header-class="is-info">{{ props.row.pei_id }}</b-table-column>
                            <b-table-column label="Codigo" header-class="is-info">{{ props.row.pei_codigo }}</b-table-column>
                            <b-table-column label="Fecha registro" header-class="is-info">{{ props.row.pei_fecha_registro }}</b-table-column>
                            <b-table-column label="Fecha aprobación" header-class="is-info">{{ props.row.pei_fecha_aprobacion }}</b-table-column>
                            <b-table-column label="Estado" header-class="is-info">
                                <b-tag :class="props.row.est_styles">{{ props.row.est_nombre }}</b-tag>
                            </b-table-column>
                            <b-table-column label="Proyecto" header-class="is-info">{{ props.row.pry_nombre }}</b-table-column>
                            <b-table-column label="Almacen destino" header-class="is-info">{{ props.row.alm_nombre }}</b-table-column>
                            <b-table-column label="Opciones" header-class="is-info">
                                <div class="nj-flex">
                                    <Button title="Ver" icon="info" @click="popup({ componente: 'ver', pei_id: props.row.pei_id, activar: true })"></Button>
                                    <Button title="Modificar" icon="edit" @click="popup({ componente: 'modificar', pei_id: props.row.pei_id, activar: true })"
                                        v-if="activarOpcion('modificar', props.row)"></Button>
                                    <Button title="Solicitar Aprobacion" icon="email" @click="solicitarAprobacion(props.row.pei_id)" v-if="activarOpcion('solicitar', props.row)"></Button>
                                    <Button title="Aprobar" icon="review" @click="popup({ componente: 'aprobar', pei_id: props.row.pei_id, activar: true })" activationCode="aprobar_pedido_items"
                                        v-if="activarOpcion('aprobar', props.row)"></Button>
                                </div>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
    <RegistrarPedidoItems v-if="activarRegistrarPedido" @close="popup($event)"></RegistrarPedidoItems>
    <ModificarPedidoItems v-if="activarModificarPedido" @close="popup($event)" :pei_id="pei_id"></ModificarPedidoItems>
    <AprobarPedidoItems v-if="activarAprobarPedido" @close="popup($event)" :pei_id="pei_id"></AprobarPedidoItems>
    <VerPedidoItems v-if="activarVerPedido" @close="popup($event)" :pei_id="pei_id"></VerPedidoItems>
</div>
</template>
<script>
import { EstadoEnum } from "../../constants"
import { PedidoItemsService, ResponseStatus, UsuarioService } from "../../rest"
import OpcionesService from "../../rest/OpcionesService"
import { Data } from "../../util"
import Toast from "../../util/toast"
import { Button, InputSelect, InputText } from "../components"
import AprobarPedidoItems from "./AprobarPedidoItems.vue"
import ModificarPedidoItems from "./ModificarPedidoItems.vue"
import RegistrarPedidoItems from "./RegistrarPedidoItems.vue"
import VerPedidoItems from "./VerPedidoItems.vue"

export default {
    name: "PedidoItems",
    components: {
        Button,
        InputText,
        InputSelect,
        RegistrarPedidoItems,
        ModificarPedidoItems,
        AprobarPedidoItems,
        VerPedidoItems,
    },
    data() {
        return {
            pedido_items: {
                est_codigo: null,
                alm_id: null,
                page: {
                    number: 1,
                    size: 10,
                    total: 0,
                    list: []
                },
            },
            pei_id: null,
            activarRegistrarPedido: false,
            activarModificarPedido: false,
            activarAprobarPedido: false,
            activarVerPedido: false,
            almacenes: [],
            estados: []
        }
    },
    methods: {
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        filterAlmacenes(items, param) {
            if (param != null) {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        activarOpcion(opcion, item) {
            let condicion = false
            switch (opcion) {
                case "modificar":
                    condicion = item.est_codigo == EstadoEnum.CREADO.est_codigo || item.est_codigo == EstadoEnum.POR_APROBAR.est_codigo
                    break
                case "solicitar":
                    condicion = item.est_codigo == EstadoEnum.CREADO.est_codigo
                    break
                case "aprobar":
                    condicion = item.est_codigo == EstadoEnum.CREADO.est_codigo || item.est_codigo == EstadoEnum.POR_APROBAR.est_codigo
                    break
            }
            return condicion
        },
        filterEstados(items, param) {
            if (param != null) {
                return items.filter(item => item.est_nombre.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        setEstado(item) {
            return item.est_nombre
        },
        changePage(number) {
            this.pedido_items.page.number = number
            this.buscar()
        },
        buscar() {
            const request = {
                pedido_items: this.pedido_items
            }
            PedidoItemsService.paginar(request).then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.pedido_items.page = response.data
                }
                else {
                    Toast.warn(response.message)
                }
            }).catch(error => {
                Toast.error(error)

            })
        },
        popup({
            componente,
            activar,
            renderizar = false,
            pei_id = null
        }) {
            switch (componente) {
                case 'registrar':
                    this.activarRegistrarPedido = activar
                    break
                case 'modificar':
                    this.pei_id = pei_id
                    this.activarModificarPedido = activar
                    break
                case 'aprobar':
                    this.pei_id = pei_id
                    this.activarAprobarPedido = activar
                    break
                case 'ver':
                    this.pei_id = pei_id
                    this.activarVerPedido = activar
                    break
            }
            if (renderizar) {
                this.buscar()
            }
        },
        solicitarAprobacion(pei_id) {
            const request = {
                pedido_items: {
                    pei_id
                }
            }
            PedidoItemsService.solicitarAprobacion(request).then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    Toast.success(response.message)
                }
                else {
                    Toast.warn(response.message)
                }
            }).catch(error => {
                Toast.error(error)

            })
        },
    },
    mounted() {
        OpcionesService
            .getOpciones({
                estado: {
                    modulo: "pedidoItems"
                },
                almacen: {
                    pry_id: UsuarioService.getUsuario().usu_nivel == 1
                        ? null
                        : UsuarioService.getUsuario().pry_id
                },
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = response.data.estados
                    this.almacenes = response.data.almacenes
                    // verificando si se solicita mostrar el pedido desde la url
                    if (
                        this.$route.params.id != undefined
                        && this.$route.params.id != null
                        && this.$route.params.action != undefined
                        && this.$route.params.action != null) {
                        this.popup({
                            pei_id: this.$route.params.id,
                            componente: this.$route.params.action,
                            activar: true
                        })
                    }
                    else {
                        // realizando la busqueda por defecto
                        this.buscar()
                    }
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped></style>